import React, { useState } from 'react';

import HistoryIcon from '@mui/icons-material/History';
import { IconButton, Tooltip } from '@mui/material';

import { ComunicadoLogsModal } from 'pages/comunicado/components/templates/ComunicadoLogsModal';
import { ListagemProvider } from 'context/ListagemContext';

type ComunicadoLogsBtn = {
    idComunicado: number;
};

export function ComunicadoLogsBtn({ idComunicado }: ComunicadoLogsBtn) {
    const [isOpenLogsModal, setIsOpenLogsModal] = useState<boolean>(false);

    return (
        <React.Fragment>
            <ListagemProvider>
                <ComunicadoLogsModal isOpen={isOpenLogsModal} setIsOpen={setIsOpenLogsModal} idComunicado={idComunicado} />
            </ListagemProvider>

            <Tooltip title="Logs de Envio de Emails">
                <IconButton sx={{ p: 0.5 }} onClick={() => setIsOpenLogsModal(true)}>
                    <HistoryIcon />
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );
}
